import React, { FC } from "react";
import { UPLOAD_STATUS, File } from "../types";
import "../index.css";

const FileItem: FC<{ file: File; retry: (file: File) => void }> = ({ file, retry }) => {
  const { name, status } = file;
  return (
    <div className="columns">
      {status === UPLOAD_STATUS.running && (
        <div className="column is-1">
          <span className="icon-text has-text-info">
            <span className="icon">
              <i className="fas fa-spinner fa-spin"></i>
            </span>
          </span>
        </div>
      )}
      {status === UPLOAD_STATUS.success && (
        <div className="column is-1">
          <span className="icon-text has-text-success">
            <span className="icon">
              <i className="fas fa-check-square"></i>
            </span>
          </span>
        </div>
      )}
      {status === UPLOAD_STATUS.error && (
        <>
          <div className="column is-1">
            <span className="icon-text has-text-danger">
              <span className="icon">
                <i className="fas fa-ban"></i>
              </span>
            </span>
          </div>
          <div className="column is-1" onClick={() => retry(file)}>
            <span className="icon-text has-text-success">
              <span className="icon">
                <i className="fas fa-redo-alt"></i>
              </span>
            </span>
          </div>
        </>
      )}
      <div className="column file-name-container">{name}</div>
    </div>
  );
};
export default FileItem;
